export default __webpack_public_path__ + "static/media/chives.c9a07d68.png";